export const mockCustomers = [
  {
    id: "1",
    name: "Rajesh Kumar Sharma",
    accountNo: "ACC-001234",
    meterId: "MTR-567890",
    address: "123 MG Road, Sector 15, Gurgaon, Haryana",
    phone: "+91-9876543210",
    location: { lat: 28.4595, lng: 77.0266 },
    deviceType: "Smart Meter v2.1",
    complaintHistory: [
      {
        id: "1",
        date: "2024-01-15",
        description: "Meter reading discrepancy",
        status: "resolved",
      },
    ],
  },
  {
    id: "2",
    name: "Priya Devi Patel",
    accountNo: "ACC-001235",
    meterId: "MTR-567891",
    address: "456 Civil Lines, Model Town, Delhi",
    phone: "+91-9123456789",
    location: { lat: 28.7041, lng: 77.1025 },
    deviceType: "Digital Meter v1.5",
    complaintHistory: [],
  },
  {
    id: "3",
    name: "Mohammad Arif Khan",
    accountNo: "ACC-001236",
    meterId: "MTR-567892",
    address: "789 Brigade Road, Bangalore, Karnataka",
    phone: "+91-8765432109",
    location: { lat: 12.9716, lng: 77.5946 },
    deviceType: "Smart Meter v2.1",
    complaintHistory: [
      {
        id: "2",
        date: "2024-02-20",
        description: "No power reading",
        status: "open",
      },
    ],
  },
  {
    id: "4",
    name: "Sunita Kumari Singh",
    accountNo: "ACC-001237",
    meterId: "MTR-567893",
    address: "321 Park Street, Kolkata, West Bengal",
    phone: "+91-7654321098",
    location: { lat: 22.5726, lng: 88.3639 },
    deviceType: "Digital Meter v1.5",
    complaintHistory: [],
  },
  {
    id: "5",
    name: "Venkatesh Iyer",
    accountNo: "ACC-001238",
    meterId: "MTR-567894",
    address: "567 Anna Salai, Chennai, Tamil Nadu",
    phone: "+91-6543210987",
    location: { lat: 13.0827, lng: 80.2707 },
    deviceType: "Smart Meter v2.1",
    complaintHistory: [],
  },
];

export const mockCustomerProfiles = [
  {
    id: "1",
    name: "Rajesh Kumar Sharma",
    accountNo: "ACC-001234",
    meterId: "MTR-567890",
    address: "123 MG Road, Sector 15, Gurgaon, Haryana",
    phone: "+91-9876543210",
    alternatePhone: "+91-9876543211",
    email: "rajesh.sharma@email.com",
    location: { lat: 28.4595, lng: 77.0266 },
    deviceType: "Smart Meter v2.1",
    complaintHistory: [
      {
        id: "1",
        date: "2024-01-15",
        description: "Meter reading discrepancy",
        status: "resolved",
      },
    ],
    profileData: {
      familySize: 4,
      occupationType: "Software Engineer",
      propertyType: "residential",
      connectionType: "single_phase",
      loadCapacity: "5 KW",
      installationDate: "2022-03-15",
      lastMaintenanceDate: "2024-01-10",
      paymentHistory: "excellent",
      specialInstructions: "Gate number 2, ring bell twice",
    },
    customFields: [
      {
        id: "1",
        fieldName: "Preferred Visit Time",
        fieldValue: "Morning (9 AM - 12 PM)",
        fieldType: "select",
        options: [
          "Morning (9 AM - 12 PM)",
          "Afternoon (12 PM - 5 PM)",
          "Evening (5 PM - 8 PM)",
        ],
      },
      {
        id: "2",
        fieldName: "Language Preference",
        fieldValue: "Hindi",
        fieldType: "select",
        options: ["Hindi", "English", "Bengali", "Tamil", "Telugu", "Marathi"],
      },
      {
        id: "3",
        fieldName: "Emergency Contact",
        fieldValue: "+91-9876543299",
        fieldType: "text",
      },
      {
        id: "4",
        fieldName: "Previous Connection Issues",
        fieldValue: "Voltage fluctuation during monsoon",
        fieldType: "textarea",
      },
    ],
    createdAt: "2022-03-15T10:00:00Z",
    updatedAt: "2024-06-15T14:30:00Z",
  },
  {
    id: "2",
    name: "Priya Devi Patel",
    accountNo: "ACC-001235",
    meterId: "MTR-567891",
    address: "456 Civil Lines, Model Town, Delhi",
    phone: "+91-9123456789",
    email: "priya.patel@email.com",
    location: { lat: 28.7041, lng: 77.1025 },
    deviceType: "Digital Meter v1.5",
    complaintHistory: [],
    profileData: {
      familySize: 6,
      occupationType: "Teacher",
      propertyType: "residential",
      connectionType: "single_phase",
      loadCapacity: "3 KW",
      installationDate: "2021-08-20",
      paymentHistory: "good",
    },
    customFields: [
      {
        id: "1",
        fieldName: "Building Floor",
        fieldValue: "3rd Floor",
        fieldType: "text",
      },
      {
        id: "2",
        fieldName: "Meter Location",
        fieldValue: "Balcony - Right side",
        fieldType: "text",
      },
    ],
    createdAt: "2021-08-20T09:00:00Z",
    updatedAt: "2024-05-10T11:20:00Z",
  },
];

export const mockTechnicians = [
  {
    id: "1",
    name: "Vikram Singh Rathore",
    email: "vikram@utility.com",
    phone: "+91-9988776655",
    status: "available",
    currentLocation: { lat: 28.6139, lng: 77.209 },
    skillSet: [
      "meter_installation",
      "electrical_repair",
      "inspection",
      "customer_profiling",
    ],
  },
  {
    id: "2",
    name: "Anjali Gupta",
    email: "anjali@utility.com",
    phone: "+91-9977665544",
    status: "busy",
    currentLocation: { lat: 28.7041, lng: 77.1025 },
    skillSet: [
      "disconnection",
      "maintenance",
      "meter_replacement",
      "customer_profiling",
    ],
  },
  {
    id: "3",
    name: "Suresh Reddy",
    email: "suresh@utility.com",
    phone: "+91-9966554433",
    status: "available",
    currentLocation: { lat: 12.9716, lng: 77.5946 },
    skillSet: [
      "inspection",
      "repair",
      "emergency_response",
      "customer_profiling",
    ],
  },
];

export const mockServiceOrders = [
  {
    id: "1",
    customerId: "1",
    customer: mockCustomers[0],
    title: "Meter Replacement Required",
    description: "Replace faulty smart meter with new digital unit",
    type: "meter_replacement",
    status: "assigned",
    priority: "high",
    assignedTechnician: mockTechnicians[0],
    createdAt: "2024-06-15T09:00:00Z",
    updatedAt: "2024-06-15T10:30:00Z",
    scheduledDate: "2024-06-18T14:00:00Z",
    photos: [],
    remarks: "",
    customFields: {
      estimatedDuration: "2 hours",
      requiredParts: "Smart Meter v2.1, Installation Kit",
    },
  },
  {
    id: "2",
    customerId: "2",
    customer: mockCustomers[1],
    title: "Service Disconnection",
    description: "Disconnect service due to non-payment",
    type: "disconnection",
    status: "pending",
    priority: "medium",
    createdAt: "2024-06-16T08:30:00Z",
    updatedAt: "2024-06-16T08:30:00Z",
    scheduledDate: "2024-06-19T11:00:00Z",
    photos: [],
    remarks: "",
    customFields: {
      disconnectionReason: "Non-payment",
      reconnectionEligible: true,
    },
  },
  {
    id: "3",
    customerId: "3",
    customer: mockCustomers[2],
    title: "Routine Inspection",
    description: "Monthly meter reading and equipment check",
    type: "inspection",
    status: "in_progress",
    priority: "low",
    assignedTechnician: mockTechnicians[2],
    createdAt: "2024-06-17T07:15:00Z",
    updatedAt: "2024-06-18T09:45:00Z",
    scheduledDate: "2024-06-18T10:00:00Z",
    photos: [],
    remarks: "Customer reported unusual readings",
    customFields: {
      lastInspection: "2024-05-17",
      meterCondition: "Good",
    },
  },
  {
    id: "4",
    customerId: "1",
    customer: mockCustomers[0],
    title: "Customer Profile Update Required",
    description:
      "Complete customer profiling and data collection for enhanced service delivery",
    type: "customer_profiling",
    status: "assigned",
    priority: "medium",
    assignedTechnician: mockTechnicians[0],
    createdAt: "2024-06-15T09:00:00Z",
    updatedAt: "2024-06-15T10:30:00Z",
    scheduledDate: "2024-06-18T14:00:00Z",
    photos: [],
    remarks: "",
    customFields: {
      profilingType: "Complete Profile",
      requiredDocuments: "ID Proof, Address Proof, Previous Bills",
    },
  },
];

